import { truthy, anyOf } from '../../../utils/util';
import { ALERT } from '../model/msg/equip';
import SingletonLoading from './../utils/SingletonLoading';

class TopBar {
  constructor(options) {
    const _ = this;

    _.option = $.extend({
      page: 'default', // default, modify, view
      wrap: null,
      global: window
    }, options);

    _.wrap = null;

    _.loading = SingletonLoading.getInstance();

    _.global = _.option.global;
  }

  init() {
    const _ = this;

    _.wrap = $(_.option.wrap);

    _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    _.setBtns();
  }

  setBtns() {
    const _ = this,
      $_ = $(_);

    $('.icon-back', _.wrap).on('click', function (evt) {
      evt.preventDefault();
      if (_.loading.isLoading) return;

      $_.trigger({type: TopBar.EVT_CLOSE});
    });

    if (anyOf(_.option.page === 'default', _.option.page === 'modify')) {
      $('.util .btn-save', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        if (_.loading.isLoading) return;

        $_.trigger({type: TopBar.EVT_SAVE});
      });

      $('.util .btn-reset', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        if (_.loading.isLoading) return;

        $_.trigger({type: TopBar.EVT_TRY_RESET});

        const isResetConfirm = _.global.confirm(ALERT.RESET_ALL_EQUIPS); // '입력하신 장비 정보가 초기화 됩니다. 진행 하시겠습니까?'
        if (truthy(isResetConfirm)) $_.trigger({type: TopBar.EVT_RESET});
      });

    } else if (_.option.page === 'view') {
      $('.util .btn-modify', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        if (_.loading.isLoading) return;

        $_.trigger({type: TopBar.EVT_MODIFY});
      });

      $('.util .btn-delete', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        if (_.loading.isLoading) return;

        $_.trigger({type: TopBar.EVT_DELETE});
      });
    }
  }

  destroy(obj = null) {
    const _ = this;

    $('.icon-back', _.wrap).off('click');

    $('.util .btn-save', _.wrap).off('click');
    $('.util .btn-reset', _.wrap).off('click');

    $('.util .btn-modify', _.wrap).off('click');
    $('.util .btn-delete', _.wrap).off('click');
  }
}

TopBar.EVT_CLOSE = 'EVT_CLOSE';
TopBar.EVT_SAVE = 'EVT_SAVE';
TopBar.EVT_TRY_RESET = 'EVT_TRY_RESET';
TopBar.EVT_RESET = 'EVT_RESET';
TopBar.EVT_MODIFY = 'EVT_MODIFY';
TopBar.EVT_DELETE = 'EVT_DELETE';

export default TopBar;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/equip/TopBar.js